export const enum ActionType {
  LoginSuccess = 'loginSuccess',
  LoginReturning = 'loginReturning',
  Logout = 'logout',
  ProfileUpdate = 'profileUpdate',
  SideNavToggle = 'sideNavToggle',
  SideNavLinkClicked = 'sideNavLinkClicked',
  LoadingComplete = 'loadingComplete',
  ConfigReceived = 'configReceived',
  PreferenceUpdate = 'preferenceUpdate',
  OnlyShowBody = 'onlyShowBody',
}
